export const CONFIG_TEMPLATE_COPY = {
    TITLE: 'Settings Templates',
    DASHBOARD_BODY: 'templates of recommended settings.',
    PLACE_BRAND: 'Brand-level',
    PLACE_STORE: 'Store-level',
    SEARCH_PLACEHOLDER: 'Search template name or tag',
    HEADING_TOOLTIP:
        'Named settings you can apply to store brands or stores. Applying writes the settings. The store brand or store does not stay linked. Editing later does not change anyone you already applied to.',
    COUNT_TOOLTIP_BRAND:
        'Brand-level. Settings that apply to the whole store brand. Not one store behaviour.',
    COUNT_TOOLTIP_STORE: 'Store-level. Settings for one store. Not brand-wide settings.',
    STATUS: 'Status',
    ACTIONS: 'Actions',
    INACTIVE: 'Inactive',
    SETTINGS_SEARCH: 'Search settings (invoice, discount, roles)',
    CLEAR_SEARCH: 'Clear search',
    FINDING_SETTINGS: 'Finding settings…',
    SHOW_EVERY_SETTING: 'Show every setting',
    CHANGED_SINCE_COPY: 'Changed since copy',
    PANE_OMIT_NOTE:
        'A setting with its tick off is not in this template. Apply skips it. Off, 0 and empty still write when the tick is on.',
    CLOCK_24: '24-hour clock',
    EMPTY_WEEKDAY: 'Empty list — this template will write no weekday timings.',
    EMPTY_CATEGORIES: 'Empty list — this template will write no categories.',
    EMPTY_LIST: 'Empty list — this template will write an empty list.',
    NO_SUBCATEGORIES: 'No subcategories',
    TAKE_DAY_OUT: 'Take this day out of this template',
    REMOVE_CATEGORY: 'Remove this category',
    ADD_CATEGORY: 'Add category',
    ADD: 'Add',
    ON: 'On',
    OFF: 'Off',
    TRUE_EMPTY_BRAND: 'No brand-level templates yet',
    TRUE_EMPTY_STORE: 'No store-level templates yet',
    FILTERED_EMPTY: 'No templates match these filters',
    CLEAR_FILTERS: 'Clear search and filters',
    ALL_STATES: 'All states',
    NONE_SELECTED: 'None selected',
    FILTERS: 'Filters',
    CLEAR_ALL: 'Clear all',
    NEW_BRAND: 'New brand-level template',
    NEW_STORE: 'New store-level template',
    DUPLICATE: 'Duplicate',
    OPEN_TEMPLATE: 'Open this template',
    TURN_ON: 'Turn on',
    TURN_OFF: 'Turn off',
    TURNING_ON: 'Turning on…',
    TURNING_OFF: 'Turning off…',
    DUPLICATING: 'Duplicating…',
    NO_TAGS: 'No tags',
    NO_TAGS_YET: 'No tags yet',
    PICK_STATES: 'Pick states',
    UNTITLED: 'Untitled template',
    SAVED: 'Saved.',
    SAVE: 'Save',
    CONTINUE: 'Continue',
    CONTINUE_TO_SETTINGS: 'Continue to settings',
    BACK: 'Back',
    BACK_TO_BRAND: 'Back to brand-level',
    BACK_TO_STORE: 'Back to store-level',
    EDIT_DETAILS: 'Edit details',
    DONE: 'Done',
    DONE_KEEPS_DRAFT: 'Done keeps these on this draft. Nothing is written until you Save.',
    THIS_TEMPLATE: 'This template',
    THIS_TEMPLATE_SUB:
        'Name, tags, states, licence types and status. Level is the list you came from.',
    APPLY: 'Apply',
    APPLY_TO_BRANDS: 'Apply to store brands',
    APPLY_TO_STORES: 'Apply to stores',
    CANNOT_APPLY: 'Cannot apply',
    APPLY_TIP:
        'Writes the settings that are in this template onto the store brands or stores you pick. They do not remember this template. There is no undo.',
    APPLY_WAIT: 'Wait for this template to finish loading or saving.',
    APPLY_DIRTY:
        'Save your changes first. Apply writes what was last saved, so unsaved edits would not go out.',
    APPLY_INACTIVE: 'Turn this template on before you can apply it.',
    APPLY_EMPTY:
        'There is nothing in this template to write. Add settings, or copy from a live store brand or store.',
    COPY_FROM_LIVE: 'Copy from live',
    SAVE_FIRST: 'Save the template first.',
    SAVE_CHANGES_FIRST: 'Save your changes first.',
    EVERY_SETTING: 'Every setting',
    IN_THIS_TEMPLATE: 'In this template',
    PUT_ALL_IN: 'Put all in',
    TAKE_ALL_OUT: 'Take all out',
    STAY: 'Stay',
    LEAVE_STAY: 'Stay on this template',
    LEAVE_DISCARD: 'Leave and discard',
    LEAVE_TITLE: 'Leave without saving?',
    LEAVE_BODY:
        'The name, tags, states or status you changed, and the settings you changed, are not saved. Leaving now discards them. Nothing live is changed either way.',
    PLACE_FAILED: 'Could not load these templates.',
    PLACE_FAIL_TITLE_BRAND: 'Brand-level templates did not load',
    PLACE_FAIL_TITLE_STORE: 'Store-level templates did not load',
    PLACE_FAIL_BODY: 'How many exist is unknown. Nothing has been written to any template.',
    PLACE_PERSIST_FAIL: 'The list did not refresh. The rows above are unchanged.',
    RETRY_BRAND_TEMPLATES: 'Retry brand-level templates',
    RETRY_STORE_TEMPLATES: 'Retry store-level templates',
    TURN_ON_FAILED: 'Turn on failed',
    TURN_OFF_FAILED: 'Turn off failed',
    LOADING_TAGS: 'Loading tags…',
    LOADING_LICENCES: 'Loading licence types…',
    LOAD_FAIL_STATES: 'Couldn’t load states',
    LOAD_FAIL_TAGS: 'Couldn’t load tags',
    LOAD_FAIL_LICENCES: 'Couldn’t load licence types',
    OPTIONS_FAIL_BODY: 'The options did not come back. Nothing on the list changed.',
    IDENTITY_FAIL_TITLE: 'This template did not load',
    IDENTITY_FAIL_BODY: 'Its name, tags and states are unknown. Nothing has been written to it.',
    FIELDS_FAIL_TITLE: 'The settings in this template did not load',
    FIELDS_FAIL_BODY:
        'What this template carries is unknown. Identity above is loaded and unchanged.',
    COPY_DID_NOT_COME: 'The copy did not come across',
    RETRY_THE_COPY: 'Retry the copy',
    NAME_REQUIRED_SAVE: 'A name is required. Nothing has been saved.',
    SAVE_FAIL_TITLE: 'Not saved',
    SAVE_FAIL_BODY:
        'Nothing was saved. Everything you typed, and every setting on screen, is still here. Nothing was written to a store brand or store.',
    RETRY_SAVE: 'Retry save',
    APPLY_REQUEST_FAIL: 'The apply did not finish',
    APPLY_REQUEST_FAIL_BODY:
        'Nothing was written to the targets in this request. The template is unchanged.',
    OVERLAY_FAIL: 'The settings to write did not load.',
    EDITOR_FAILED: 'Could not load this template.',
    SCHEMA_FAILED: 'Could not load settings.',
    OPTIONS_FAILED: 'Could not load these options.',
    RETRY: 'Retry',
    RETRY_PLACE: 'Retry this place',
    RETRY_OPTIONS: 'Retry these options',
    RETRY_ROW: 'Retry',
    LOAD_MORE: 'Load more',
    MORE_FAILED: 'The next page did not come back. The rows above are unchanged.',
    NAME: 'Name',
    TAGS: 'Tags',
    STATES: 'States',
    LICENCE_TYPE: 'Licence type',
    LICENCE_TYPES: 'Licence types',
    NAME_HELPER: "This is how you'll find it later.",
    STATES_HELPER: 'Pick All states, or the states this template is for.',
    TAGS_HINT: 'Free text. More than one is fine.',
    TAGS_HELPER: 'Optional. Tags help you find this template later.',
    LICENCE_HELPER: 'Pick States first — licence codes are state-specific.',
    COPY_NAME_FIRST: 'Name this template first.',
    IDENTITY_SAVE_NOTE:
        'Nothing is saved yet. One Save at the end writes the name, tags, states, licence types and every setting together.',
    FOOTER_SAVE_NOTE:
        'One Save writes the name, tags, states, licence types and every setting in this template.',
    FOOTER_APPLY_NOTE:
        'Nothing is written to any store brand or store until you apply this template.',
    STATES_TOOLTIP:
        'All states, or the states this template is written for. Filtering to a state also shows all-states templates.',
    LICENCE_TOOLTIP:
        "Helps you find and group templates. Does not change which settings are in this template. A licence code means something different in each state — this list only shows codes for the states you've already picked.",
    STATUS_TOOLTIP:
        'Inactive templates stay in this list. There is no delete. You cannot apply an inactive template.',
    ACTIVE: 'Active',
    ADD_TAG: 'Add',
    ADD_NEW_TAG: 'Add new tag',
    COPY_NAME_REQUIRED: 'Name is required before copying from live.',
    COPY_SEARCH_BRAND: 'Search store brands by name',
    COPY_SEARCH_STORE: 'Search store name or district',
    COPY_GROUPED_BY_DISTRICT:
        'Grouped by district. Open a district to pick a store, or filter to one store brand.',
    COPY_EMPTY_UNTIL: 'Type at least 2 characters to search',
    COPY_REPLACE_WARNING: 'This replaces the settings currently in this template.',
    COPY_CONFIRM: 'Copy from this store brand',
    COPY_CONFIRM_STORE: 'Copy from this store',
    COPY_CANCEL: 'Cancel',
    COPY_COPYING: 'Copying settings…',
    COPY_BRAND_TITLE: 'Copy from a live store brand',
    COPY_STORE_TITLE: 'Copy from a live store',
    COPY_STATE_CHIP: 'State',
    COPY_STORE_BRAND_CHIP: 'Store brand',
    COPY_END_OF_LIST: 'End of list',
    COPY_CLEAR_SEARCH_FILTERS: 'Clear search and filters',
    COPY_STATE_OPTIONS_FAIL: 'State options did not load',
    COPY_STATE_OPTIONS_WAIT: 'Loading states…',
    COPY_BRAND_OPTIONS_WAIT: 'Loading store brands…',
    COPY_BRAND_OPTIONS_FAIL: 'Couldn’t load store brands',
    COPY_OPTIONS_UNCHANGED: 'The list behind is unchanged.',
    COPY_BRAND_SEARCH: 'Search store brands',
    COPY_BRAND_NO_HIT: 'No store brand matches that.',
    COPY_REPLACE_BANNER_TITLE: 'This replaces the settings currently in this template',
    INCLUDE_OTHER_STATES: 'Include other states',
    SELECT_ALL_MATCHING: 'Select all matching',
    NOTHING_SELECTED: 'Nothing selected',
    CLEAR_SELECTION: 'Clear selection',
    APPLY_GROUPED_BY_DISTRICT:
        'Grouped by district. Select a whole district, or filter to one store brand.',
    APPLY_FOOTER_EMPTY: 'Pick who to write to. There is no undo.',
    APPLY_FOOTER_SELECTED: 'Writes only the settings in this template. There is no undo.',
    APPLY_WRITING: 'Writing settings…',
    APPLY_TARGETS: 'Apply to selected',
    RETRY_FAILED: 'Retry failed',
    APPLIED: 'Applied',
    FAILED: 'Failed',
    NO_STORE_BRANDS: 'No store brands yet',
    NO_STORES: 'No stores yet',
    CONFIRM_LARGE_APPLY: 'This will apply to more than 500 matching targets. Continue?',
    NAME_REQUIRED_COPY: 'Name is required.',
} as const;

export function copiedFrom(name: string): string {
    return `Copied from ${name}.`;
}

export function appliedProgress(done: number, total: number): string {
    return `Applied ${done} of ${total}`;
}

export function targetNoun(level: 'STORE_BRAND' | 'STORE', plural = true): string {
    if (level === 'STORE_BRAND') return plural ? 'store brands' : 'store brand';
    return plural ? 'stores' : 'store';
}

export function placeNoun(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND' ? 'brand-level templates' : 'store-level templates';
}

export function placeFailTitle(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.PLACE_FAIL_TITLE_BRAND
        : CONFIG_TEMPLATE_COPY.PLACE_FAIL_TITLE_STORE;
}

export function placeFailRetry(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.RETRY_BRAND_TEMPLATES
        : CONFIG_TEMPLATE_COPY.RETRY_STORE_TEMPLATES;
}

export function rowStatusFailedLabel(activeStatus: 'Active' | 'Inactive'): string {
    return activeStatus === 'Active'
        ? CONFIG_TEMPLATE_COPY.TURN_OFF_FAILED
        : CONFIG_TEMPLATE_COPY.TURN_ON_FAILED;
}

export function nameClashBody(level: 'STORE_BRAND' | 'STORE', name: string): string {
    const levelWord = level === 'STORE_BRAND' ? 'brand-level' : 'store-level';
    return `Another ${levelWord} template is already called “${name}”.`;
}

export function copyDidNotComeBody(
    level: 'STORE_BRAND' | 'STORE',
    sourceName?: string | null
): string {
    const source = sourceName?.trim() || `the live ${targetNoun(level, false)}`;
    return `Nothing was written to ${source}. The name, tags and states above are as you left them.`;
}

export function trueEmptyTitle(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.TRUE_EMPTY_BRAND
        : CONFIG_TEMPLATE_COPY.TRUE_EMPTY_STORE;
}

export function newTemplateLabel(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.NEW_BRAND
        : CONFIG_TEMPLATE_COPY.NEW_STORE;
}

export function listPath(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? '/config-templates/brand-level'
        : '/config-templates/store-level';
}

export function editorPath(level: 'STORE_BRAND' | 'STORE', id?: string): string {
    const base = listPath(level);
    return id ? `${base}/${id}` : `${base}/new`;
}

export function suggestedCopyName(name: string): string {
    const trimmed = name.trim();
    if (!trimmed) return 'Copy of template';
    if (trimmed.toLowerCase().startsWith('copy of ')) return `${trimmed} copy`;
    return `Copy of ${trimmed}`;
}

export function licenceEmptyCopy(state: string): string {
    return `No licence types set up yet for ${state}.`;
}

export function rowSettingsLine(count: number | null | undefined): string {
    const n = typeof count === 'number' && Number.isFinite(count) ? count : 0;
    return `${n} ${n === 1 ? 'setting' : 'settings'}`;
}

export function settingsInCount(inCount: number, total: number): string {
    return `${inCount} of ${total} settings in this template`;
}

export function settingsBadgeLabel(inCount: number): string {
    return `${inCount} SETTINGS`;
}

export function railTotalLine(inCount: number, total: number): string {
    return `${inCount} / ${total} in this template`;
}

export function paneCountLine(inCount: number, total: number): string {
    return `${inCount} of ${total} in this template`;
}

export function paneChangedCountLine(count: number): string {
    return count === 1
        ? '1 setting changed since the copy'
        : `${count} settings changed since the copy`;
}

export function matchLabel(count: number): string {
    return `${count} ${count === 1 ? 'match' : 'matches'}`;
}

export function changedRailLabel(count: number): string {
    return `${count} changed`;
}

export function changedRailNote(sourceName?: string | null): string {
    return sourceName ? `vs ${sourceName}` : '';
}

export function changedNothingLine(sourceName?: string | null): string {
    return `Nothing changed since ${sourceName || 'the copy'}. This template holds that copy exactly as it came across.`;
}

export function searchJumpLine(args: {
    query: string;
    matches: number;
    groupTitle: string;
    partTitle: string;
}): string {
    if (args.matches === 0) return `No setting matches “${args.query}”`;
    const noun = args.matches === 1 ? 'setting matches' : 'settings match';
    return `Jumped to ${args.groupTitle} › ${args.partTitle} · ${args.matches} ${noun} across the rail`;
}

export function paneEmptyTitle(args: {
    query?: string;
    changed?: boolean;
    inOnly?: boolean;
}): string {
    if (args.query) return `Nothing here matches “${args.query}”`;
    if (args.changed) return 'Nothing changed since the copy';
    if (args.inOnly) return 'Nothing from this part is in this template';
    return 'Nothing to show here';
}

export function paneEmptyBody(args: {
    query?: string;
    changed?: boolean;
    sourceName?: string | null;
}): string {
    if (args.query) {
        return 'Clear the search, or pick another part in the rail — the rail shows where the matches are.';
    }
    if (args.changed) {
        return `Every setting is still exactly as it came across from ${args.sourceName || 'the copy'}.`;
    }
    return 'Switch to Every setting to put some in.';
}

export function copiedFromLine(name: string): string {
    return `Copied from ${name}`;
}

export function backToListLabel(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.BACK_TO_BRAND
        : CONFIG_TEMPLATE_COPY.BACK_TO_STORE;
}

export function identitySummaryLine(identity: {
    allStates: boolean;
    states: string[];
    tags: string[];
    licenceTypes: unknown[];
}): string {
    const states = identity.allStates
        ? CONFIG_TEMPLATE_COPY.ALL_STATES
        : identity.states.length === 0
          ? 'No states yet'
          : `${identity.states.length} ${identity.states.length === 1 ? 'state' : 'states'}`;
    const tags =
        identity.tags.length === 0
            ? 'No tags yet'
            : `${identity.tags.length} ${identity.tags.length === 1 ? 'tag' : 'tags'}`;
    const licences =
        identity.licenceTypes.length === 0
            ? 'No licence types'
            : `${identity.licenceTypes.length} ${identity.licenceTypes.length === 1 ? 'licence type' : 'licence types'}`;
    return `${states} · ${tags} · ${licences}`;
}

export function copyPickerTitle(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.COPY_BRAND_TITLE
        : CONFIG_TEMPLATE_COPY.COPY_STORE_TITLE;
}

export function copyPickerSubtitle(level: 'STORE_BRAND' | 'STORE', hasSettings: boolean): string {
    if (hasSettings) return CONFIG_TEMPLATE_COPY.COPY_REPLACE_WARNING;
    const noun = targetNoun(level, false);
    return `This copies that ${noun}’s settings into this template. Nothing live is changed.`;
}

export function applyActionLabel(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.APPLY_TO_BRANDS
        : CONFIG_TEMPLATE_COPY.APPLY_TO_STORES;
}

export type ApplyBlockReason = 'loading' | 'unsaved' | 'dirty' | 'inactive' | 'empty' | null;

export function applyTipTitle(blocked: boolean): string {
    return blocked ? CONFIG_TEMPLATE_COPY.CANNOT_APPLY : CONFIG_TEMPLATE_COPY.APPLY;
}

export function applyWritesLine(count: number): string {
    return `Writes ${count} setting${count === 1 ? '' : 's'}`;
}

export function applySelectedLine(count: number): string {
    return count === 0 ? CONFIG_TEMPLATE_COPY.NOTHING_SELECTED : `${count} selected`;
}

export function applySelectAllLabel(count: number): string {
    return `Select all matching · ${count}`;
}

export function applySelectDistrictLabel(count: number): string {
    return `Select all ${count}`;
}

export function applyConfirmLabel(level: 'STORE_BRAND' | 'STORE', count: number): string {
    const noun =
        count === 1 ? (level === 'STORE_BRAND' ? 'store brand' : 'store') : targetNoun(level);
    return `Apply to ${count} ${noun}`;
}

export function applyReceiptTitle(
    level: 'STORE_BRAND' | 'STORE',
    written: number,
    failed: number
): string {
    if (failed > 0) return `Written to ${written} · ${failed} failed`;
    const noun =
        written === 1 ? (level === 'STORE_BRAND' ? 'store brand' : 'store') : targetNoun(level);
    return `Written to ${written} ${noun}`;
}

export function applyReceiptBody(failed: number): string {
    if (failed > 0) {
        return `The ${failed} that failed were not written. Retry writes only those.`;
    }
    return 'They do not remember this template. There is no undo.';
}

export function applyRetryLabel(failed: number): string {
    return `Retry ${failed} failed`;
}

export function applyFooterNote(selected: number): string {
    return selected === 0
        ? CONFIG_TEMPLATE_COPY.APPLY_FOOTER_EMPTY
        : CONFIG_TEMPLATE_COPY.APPLY_FOOTER_SELECTED;
}

export function applyPageNote(shown: number, total: number): string {
    if (shown >= total) return '';
    return `Showing the first ${shown} of ${total} matching. Select all matching does not need every row on screen.`;
}

export function applyTipBody(reason: ApplyBlockReason): string {
    switch (reason) {
        case 'loading':
            return CONFIG_TEMPLATE_COPY.APPLY_WAIT;
        case 'unsaved':
            return CONFIG_TEMPLATE_COPY.SAVE_FIRST;
        case 'dirty':
            return CONFIG_TEMPLATE_COPY.APPLY_DIRTY;
        case 'inactive':
            return CONFIG_TEMPLATE_COPY.APPLY_INACTIVE;
        case 'empty':
            return CONFIG_TEMPLATE_COPY.APPLY_EMPTY;
        default:
            return CONFIG_TEMPLATE_COPY.APPLY_TIP;
    }
}

export function copyPickerTipBody(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? 'Copies that store brand’s brand-wide settings into this template. The live store brand is not changed.'
        : 'Copies that store’s store settings into this template. The live store is not changed.';
}

export function copyLoadingLine(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? 'Loading store brands… Blank is not zero.'
        : 'Loading stores… Blank is not zero.';
}

export function copyWaitingLine(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? 'Counting matching store brands…'
        : 'Counting matching stores…';
}

export function copyFailTitle(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND' ? 'Store brands did not load' : 'Stores did not load';
}

export function copyFailBody(): string {
    return 'How many exist is unknown. The template you have open is untouched.';
}

export function copyFailRetry(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND' ? 'Retry store brands' : 'Retry stores';
}

export function copyEmptyBody(level: 'STORE_BRAND' | 'STORE'): string {
    const noun = targetNoun(level, false);
    return `There is no live ${noun} to copy from. You can still author this template setting by setting.`;
}

export function copyNeedsQueryBody(level: 'STORE_BRAND' | 'STORE', catalogTotal: number): string {
    if (level === 'STORE_BRAND') {
        return `There are ${catalogTotal} live store brands. Search by name, and narrow with the State filter if you need to.`;
    }
    return `There are ${catalogTotal} live stores. Search by store name or district, and narrow with the State and Store brand filters if you need to.`;
}

export function copyFilteredEmptyTitle(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? 'No store brand matches your search and filters'
        : 'No store matches your search and filters';
}

export function copyFilteredEmptyBody(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? 'No live store brand matches that. Try a different name, or clear the filters.'
        : 'No live store matches that. Try a different name or district, or clear the filters.';
}

export function copyConfirmLabel(level: 'STORE_BRAND' | 'STORE'): string {
    return level === 'STORE_BRAND'
        ? CONFIG_TEMPLATE_COPY.COPY_CONFIRM
        : CONFIG_TEMPLATE_COPY.COPY_CONFIRM_STORE;
}

export function copyFooterNote(level: 'STORE_BRAND' | 'STORE', selectedName?: string): string {
    if (selectedName) return `${selectedName} is not changed by this copy.`;
    return `Pick one live ${targetNoun(level, false)} to copy from. It is not changed.`;
}

export function copyReplaceBody(
    count: number,
    dirty: boolean,
    level: 'STORE_BRAND' | 'STORE'
): string {
    const noun = targetNoun(level, false);
    const n = `${count} setting${count === 1 ? '' : 's'}`;
    const edits = dirty ? ', including unsaved edits,' : '';
    return `The ${n} in this template${edits} will be replaced by a copy from the ${noun} you pick.`;
}

export function copyBrandMeta(item: {
    state?: string | null;
    mixedStates?: boolean | string[];
    storeCount?: number;
}): string {
    const parts: string[] = [];
    if (item.mixedStates) parts.push('Mixed states');
    else if (item.state) parts.push(item.state);
    if (typeof item.storeCount === 'number' && Number.isFinite(item.storeCount)) {
        parts.push(`${item.storeCount} ${item.storeCount === 1 ? 'store' : 'stores'}`);
    }
    return parts.join(' · ');
}

export function copyStoreMeta(item: {
    storeBrandName?: string;
    state?: string;
    district?: string;
}): string {
    return [item.storeBrandName, item.district, item.state].filter(Boolean).join(' · ');
}

export function copyCountLine(args: {
    level: 'STORE_BRAND' | 'STORE';
    gated: boolean;
    ready: boolean;
    counting: boolean;
    matching: number;
    catalogTotal: number | null;
}): string {
    const noun = targetNoun(args.level);
    if (args.gated) return '';
    if (!args.ready || args.counting) {
        return args.level === 'STORE_BRAND' ? 'Counting store brands…' : 'Counting stores…';
    }
    const catalog = args.catalogTotal == null ? noun : `${args.catalogTotal} ${noun}`;
    return `${args.matching} matching · ${catalog}`;
}

export function copyLoadMoreLabel(left: number): string {
    return `Load 25 more · ${left} left`;
}

export function copyPageNote(shown: number, total: number): string {
    if (shown >= total) return '';
    return `Showing the first ${shown} of ${total} matching. Narrow with search or a filter rather than paging through everything.`;
}

export function copyDistrictCount(count: number): string {
    return `${count} ${count === 1 ? 'store' : 'stores'}`;
}

export function copyShowMoreInGroup(left: number): string {
    return `Show 10 more · ${left} left`;
}

export function listCountLine(
    shown: number,
    total: number,
    level: 'STORE_BRAND' | 'STORE',
    filtered = false
): string {
    const noun = placeNoun(level);
    if (filtered) return `${shown} of ${total} ${noun}`;
    return `${total} ${noun}`;
}
